"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterMenuSanduiche = void 0;
var contextos_frontend_1 = require("@aura/contextos-frontend");
var utils_frontend_1 = require("@aura/utils-frontend");
var icons_1 = require("@lift/assets/dist/assets/globals/icons");
var LftIconBase_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftIconBase"));
var LftTypography_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftTypography"));
var react_1 = __importStar(require("react"));
var tags_ga_1 = require("../../utils/tags-ga/tags-ga");
var dialog_link_externo_1 = require("../dialog-link-externo");
var icon_with_hyperlink_1 = require("../icon-with-hyperlink/icon-with-hyperlink");
var label_with_hyperlink_1 = require("../label-with-hyperlink/label-with-hyperlink");
var footer_menu_sanduiche_styles_1 = require("./footer-menu-sanduiche.styles");
var FooterMenuSanduiche = function () {
    var _a = (0, contextos_frontend_1.useConfig)(), domain = _a.domain, brand = _a.brand, getValueOrThrow = _a.getValueOrThrow;
    var signOut = (0, contextos_frontend_1.useAuth)().signOut;
    var acessarLinkExterno = (0, utils_frontend_1.useLinkExterno)().acessarLinkExterno;
    var _b = (0, react_1.useState)(false), openDialog = _b[0], setOpenDialog = _b[1];
    var openDialogAction = function () { return setOpenDialog(true); };
    var aoDeslogarUsuario = function () {
        sessionStorage.setItem('realizouIntegracaoLogin', 'false');
        signOut();
    };
    var onClickContinuar = function () {
        var urlRedefinicaoSenha = getValueOrThrow('URL_REDIRECT_REDEFINIR_SENHA');
        acessarLinkExterno(urlRedefinicaoSenha);
        setOpenDialog(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(footer_menu_sanduiche_styles_1.MenuFooterStyled, null,
            react_1.default.createElement(tags_ga_1.TagsGa, { category: ['aura', brand, domain], action: ['menu-perfil', 'botao-alterar-senha'], label: ['alterar-senha-de-acesso'] },
                react_1.default.createElement(footer_menu_sanduiche_styles_1.TaggedLink, null,
                    react_1.default.createElement(label_with_hyperlink_1.LabelWithHyperlink, { secundary: true, label: "Alterar senha de acesso", onClick: openDialogAction }))),
            react_1.default.createElement(tags_ga_1.TagsGa, { category: ['aura', brand, domain], action: ['clique', 'sair'], label: ['clique', 'sair'], eventType: "clique" },
                react_1.default.createElement(footer_menu_sanduiche_styles_1.TaggedLink, null,
                    react_1.default.createElement(icon_with_hyperlink_1.IconWithHyperlink, { secundary: true, icon: react_1.default.createElement(LftIconBase_1.default, { icon: icons_1.X, size: 'sm' }), label: "Sair", onClick: aoDeslogarUsuario })))),
        openDialog && (react_1.default.createElement(dialog_link_externo_1.DialogLinkExterno, { tagOnClickContinuar: {
                category: ['aura', brand, domain],
                action: ['menu-perfil', 'modal-alterar-senha'],
                label: ['continuar'],
            }, actions: { dialogState: setOpenDialog }, hideCheckbox: true, contentTitle: "Seu acesso a esta plataforma \u00E9 pelo LOGIN UNIFICADO MICROSOFT.", componenteDescricao: function () { return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(LftTypography_1.default, { component: "paragraph", size: "small" }, "Voc\u00EA est\u00E1 sendo redirecionado para o ambiente de redefini\u00E7\u00E3o de senha da Microsoft."),
                react_1.default.createElement(LftTypography_1.default, { component: "paragraph", size: "small" }, "Ao alterar sua senha voc\u00EA a estar\u00E1 alterando em todas as plataformas que utilizam esse login (Sala de aula virtual, Teams, Wifi da unidade/polo, acesso ao VDI)."))); }, labelHeader: "Aten\u00E7\u00E3o!", onClick: onClickContinuar }))));
};
exports.FooterMenuSanduiche = FooterMenuSanduiche;
